<template lang="pug">
div(:class="optionClass" :id="id")
  div(@click="showDropdown = !showDropdown ")
    span.dropdown-text(v-if='selectText' :class="innerTextClass") {{ selectText }}
    span(v-else :class="innerTextClass") {{ placeholder }}
    i.popup-iconUnfoldOption.icon-unfold
  div.dropdown-content(:class="[showDropdown ? 'show' : '', isEduChild ? 'show--lastItem': '']")
    div(v-for='(info, idx) in infos' @click="selectDropdown(info)") {{ info.name }}
</template>
<script>
import $ from 'jquery';
export default {
  props: {
    infos: Array,
    placeholder: String,
    selectText: String,
    optionClass: String,
    innerTextClass: String,
    id: String,
    isEduChild: Boolean
  },
  data() {
    return {
      showDropdown: false
    };
  },
  mounted() {
    $(document).click(e => {
      if (document.getElementById(this.id))
        if (!$.contains(document.getElementById(this.id), e.target))
          this.showDropdown = false;
    });
  },
  methods: {
    selectDropdown(event) {
      this.showDropdown = false;
      this.localSelectText = event.name;
      this.$emit('selectDropdown', event);
    }
  }
};
</script>
<style scoped src="./dropdown.vue.css"></style>
